import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

export interface EmailTemplate {
  key: string;
  value: string;
  detail?: string;
  active?: boolean;
}

export interface EmailTemplateResponse {
  action: string;
  emailSubject: string;
  emailBody: string;
  buttonText: string;
  buttonLink: string;
  recipient: string;
}

@Component({
  selector: 'app-admin-email-templates',
  templateUrl: './admin-email-templates.component.html',
  styleUrls: ['./admin-email-templates.component.scss']
})
export class AdminEmailTemplatesComponent implements OnInit {

  emailTemplates: EmailTemplate[] = [];
  selectedTemplate?: string;
  // selectedTemplateResponse: EmailTemplateResponse = {
  //   action: '',
  //   emailSubject: '',
  //   emailBody: '',
  //   buttonText: '',
  //   buttonLink: '',
  //   recipient: ''
  // };

  selectedProfile: string = 'investor';

  emailFormGroup: FormGroup = new FormGroup({
    action: new FormControl(''),
    emailSubject: new FormControl(''),
    emailBody: new FormControl(''),
    buttonText: new FormControl(''),
    buttonLink: new FormControl(''),
    recipient: new FormControl('')
  });

  constructor(private adminService: AdminService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    // get the templates from the server
    this.adminService.getEmailTemplates().subscribe((templates: EmailTemplate[]) => {
      this.emailTemplates = templates;
    });
  }

  selectProfile(profile: string): void {
    this.selectedProfile = profile;
    this.selectTemplateResponse();
  }

  selectTemplate(templateKey: string): void {
    this.selectedTemplate = templateKey;
    this.selectTemplateResponse();
  }

  selectTemplateResponse(): void {
    if (!this.selectedTemplate) {
      return;
    }

    this.adminService.getEmailTemplate(this.selectedTemplate, this.selectedProfile).subscribe({
      next: (templateResponse: EmailTemplateResponse) => {
        // console.log("Selected Template", templateResponse);
        this.emailFormGroup.patchValue(templateResponse);
      },
      error: (err) => {
        console.error('Error fetching template', err);
        if (err.status === 404) {
          this.toastrService.warning('Template not found for selected profile', 'Warning');
        } else {
          this.toastrService.error('Error fetching template', 'Error');
        }
      }
    });
  }

  saveTemplate(): void {
    var payload = this.emailFormGroup.getRawValue() as EmailTemplateResponse;
    console.log("Saving Template", payload);
    this.adminService.setEmailTemplate(payload, this.selectedProfile).subscribe({
      next: () => {
        console.log('Template saved successfully!');
        this.toastrService.success('Template saved successfully!', 'Success');
      },
      error: (err) => {
        console.error('Error saving template', err);
        this.toastrService.error('Error saving template', 'Error');
      }
    });
  }
}
